import pluralize from 'pluralize'

export function formatClipDuration(seconds: number, minimal = true): string {
  if (seconds <= 5.0) {
    return minimal ? '5s' : '5 secs'
  } else if (seconds <= 50) {
    const secs = Math.round(seconds / 5) * 5
    return minimal ? `${secs}s` : pluralize('sec', secs, true)
  } else {
    const mins = seconds < 60 ? 1 : Math.round(seconds / 60)
    return minimal ? `${mins}m` : pluralize('min', mins, true)
  }
}
